import Dashboard from '../containers/dashboard'
import PaymentsPendingRoutingManagement from '../containers/payments-pending-routing-management'

const PaymentsPendingRouting = () => {
  return (
    <Dashboard>
      <PaymentsPendingRoutingManagement />
    </Dashboard>
  )
}

export default PaymentsPendingRouting
